module.exports = __webpack_public_path__ + "static/media/bg.f841d16f.png";